module.exports = __webpack_public_path__ + "img/InstagramIcon.126a19da.svg";